import React, { useEffect, useState } from "react";
import axios from "axios";
import ChatWindow from "./ChatWindow.jsx";
import TicketList from "./TicketList.jsx";

const SupportTicket = () => {
  const [tickets, setTickets] = useState([]);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  //################################################################
  // ✅ Load support tickets from backend
  const loadTickets = async () => {
    console.log("🔄 [Frontend] Loading tickets from backend API...");
    try {
      const response = await axios.get(`${apiBaseURL}/api/support-ticket`);
      console.log("✅ [Frontend] Tickets loaded successfully:", response.data);
      setTickets(response.data);
    } catch (err) {
      console.error("❌ [Frontend] Error loading tickets:", err);
      setError("Failed to fetch tickets.");
    } finally {
      setLoading(false);
      console.log("📦 [Frontend] Ticket loading process finished.");
    }
  };

  useEffect(() => {
    console.log("📥 [Frontend] useEffect triggered - initializing ticket load...");
    loadTickets();
  }, [apiBaseURL]);

  //################################################################
  // ✅ Open chat window for a selected ticket
  const handleOpenChat = (ticketId) => {
    console.log("💬 [Frontend] Opening chat for ticket ID:", ticketId);
    const ticket = tickets.find((t) => t.ticket_id === ticketId);
    if (ticket) {
      console.log("✅ [Frontend] Found ticket for chat:", ticket);
      setSelectedTicket(ticket);
    } else {
      console.warn("⚠️ [Frontend] No ticket found with ID:", ticketId);
    }
  };

  //################################################################
  // ✅ Close chat window
  const handleCloseChat = () => {
    console.log("❌ [Frontend] Closing chat window.");
    setSelectedTicket(null);
  };

  //################################################################
// ✅ Close ticket via backend API and reload tickets from backend
const handleCloseTicket = async (ticketId) => {
  console.log("🔒 [Frontend] Initiating ticket close for ID:", ticketId);

  try {
    console.log(`📤 [Frontend] Sending PUT request to close ticket ID: ${ticketId}`);
    const response = await axios.put(`${apiBaseURL}/api/support-ticket/close/${ticketId}`);
    console.log("✅ [Frontend] Ticket closed successfully on server:", response.data.ticket);

    // Instead of just updating local state — reload fresh ticket list from backend
    console.log("🔄 [Frontend] Reloading updated ticket list from backend...");
    await loadTickets();

    console.log(`🎉 [Frontend] Ticket #${ticketId} closed and ticket list refreshed.`);
    alert(`✅ Ticket #${ticketId} has been closed successfully!`);
  } catch (err) {
    console.error("❌ [Frontend] Error closing ticket on server:", err);
    alert("Failed to close ticket. Please try again.");
  }
};

  //################################################################
  // ✅ Render loading, error or ticket list
  if (loading) return <div>Loading tickets...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="p-6" style={{ marginLeft: "16rem" }}>
      <h1 className="text-2xl font-semibold mb-4">Support Tickets</h1>

      {tickets.length === 0 ? (
        <div>No tickets found.</div>
      ) : (
        <div className="overflow-x-auto">
          <TicketList
            tickets={tickets}
            handleChat={handleOpenChat}
            handleCloseTicket={handleCloseTicket}
          />
        </div>
      )}

      {selectedTicket && (
        <ChatWindow ticket={selectedTicket} closeChat={handleCloseChat} />
      )}
    </div>
  );
};

export default SupportTicket;
